// extracted by mini-css-extract-plugin
module.exports = {"block":"i_S1","label":"i_S2","iconContainer":"i_S3","icon":"i_S4","active":"i_S5"};